<kal-input *ngIf="disabled; else InputAutocompleteTemplate"
           [formControl]="formControl"
           [placeholder]="placeholder"
           icon="keyboard_arrow_down"
           [label]="label">
</kal-input>

<ng-template #InputAutocompleteTemplate>
    <kal-input
        [formControl]="formControl"
        [kalAutocomplete]="datasource"
        [label]="label"
        [required]="required"
        (iconClicked)="setOptionValue()"
        (kalAutocompleteSelected)="pickOption($event)"
        (kalAutocompleteClosed)="clearOption()"
        icon="keyboard_arrow_down"
        [placeholder]="placeholder"
        [kalAutocompleteOptionTemplate]="optionsTemplate">
    </kal-input>
</ng-template>

<ng-template #optionsTemplate let-option="option">
    <ng-container *ngTemplateOutlet="(option.searchbarTemplate || defaultOptionTemplate); context:{searchbarValue: option.selected}">
    </ng-container>

    <ng-template #defaultOptionTemplate>
        {{ option.label }}
    </ng-template>
</ng-template>


